import React from "react";

const StatusPill = ({ status }) => {
  const normalized = String(status || "active").toLowerCase();
  const styles = {
    active: "bg-emerald-50 text-emerald-700",
    paused: "bg-amber-50 text-amber-700",
    completed: "bg-blue-50 text-blue-700",
    cancelled: "bg-red-50 text-red-600",
    // UPI AutoPay — waiting for mandate authorisation
    pending_mandate: "bg-indigo-50 text-indigo-700",
  };

  const displayLabel =
    normalized === "pending_mandate" ? "Pending Mandate" : normalized;

  return (
    <span
      className={`rounded-full px-3 py-1 text-xs font-bold capitalize ${
        styles[normalized] || "bg-gray-100 text-gray-600"
      }`}
    >
      {displayLabel}
    </span>
  );
};

export default StatusPill;
